import React from 'react';
import { useTranslation } from 'react-i18next';
import CatalogManager from './CatalogManager';
import { Employee } from '../../types/catalogs';

const EmployeesPage: React.FC = () => {
  const { t } = useTranslation();
  const columns = [
    { key: 'codigo', label: t('code') },
    { key: 'nombre', label: t('name') },
    { key: 'apellidos', label: t('lastName') },
  ];

  const formFields = [
    { name: 'codigo', label: t('code'), type: 'text' as const, required: true },
    { name: 'nombre', label: t('name'), type: 'text' as const, required: true },
    { name: 'apellidos', label: t('lastName'), type: 'text' as const, required: true },
    { name: 'activo', label: t('active'), type: 'checkbox' as const },
  ];

  const createEmptyItem = () => ({
    codigo: '',
    nombre: '',
    apellidos: '',
    activo: true,
  });

  const validateItem = (item: any) => {
    if (!item.codigo?.trim()) return t('requiredCode');
    if (!item.nombre?.trim()) return t('requiredName');
    if (!item.apellidos?.trim()) return t('requiredLastName');
    return null;
  };

  return (
    <CatalogManager<Employee>
      title={t('catalogEmployees')}
      apiEndpoint="employees"
      columns={columns}
      formFields={formFields}
      getItemId={(item) => item.id}
      getItemAttributes={(item) => item.attributes}
      createEmptyItem={createEmptyItem}
      validateItem={validateItem}
    />
  );
};

export default EmployeesPage;
